import React, { useState, Fragment } from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop } from '@material-ui/core';
import i18n from 'i18next';

import Fetch from 'helpers/fetch';
import { REGISTER_USER } from 'constants/apis';
import RegistrationForm from 'Components/Login/RegisterationForm';

import { Loader } from 'Components/index';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const Registration = () => {
  const classes = useStyles();

  const [state, setState] = useState({
    hasError: false,
    errorMessage: '',
    isComplete: false,
    isSubmitting: false,
  });

  const handleRegisterSubmit = (values) => {
    localStorage.setItem('Region', values.region);

    setState({
      ...state,
      isSubmitting: true,
      hasError: false,
      isComplete: false,
      errorMessage: '',
    });

    const params = {
      Name: values.name,
      Location: values.region,
      Email: values.email,
      Company: values.company,
      PhoneNumber: values.phone,
      TEL_EXT: values.ext,
      Language: values.language,
      Petroleum: values.services.includes('petroleum'),
      Environmental: values.services.includes('environmental'),
      Food: values.services.includes('food'),
      Hygiene: values.services.includes('Hygiene'),
    };

    Fetch.Post(REGISTER_USER, params)
      .then(() => {
        setState({
          ...state,
          isSubmitting: false,
          hasError: false,
          isComplete: true,
        });
      })
      .catch((err) => {
        err.response.json().then((data) =>
          setState({
            ...state,
            errorMessage: data.Message,
            isSubmitting: false,
            hasError: false,
          }),
        );
      });
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;

    if (name && name === 'region') {
      localStorage.setItem('Region', value);
    }
  };
  return (
    <Fragment>
      <Formik
        onSubmit={handleRegisterSubmit}
        initialValues={{
          name: '',
          company: '',
          phone: '',
          ext: '',
          email: '',
          region: 0,
          language: 0,
          services: [],
          code: '',
        }}
        validationSchema={yup.object().shape({
          name: yup.string().required(i18n.t('registration:form:name:error')),
          company: yup
            .string()
            .required(i18n.t('registration:form:company:error')),
          language: yup
            .string()
            .matches(/^([^0-9]*)$/, i18n.t('registration:form:language:error')),
          phone: yup
            .string()
            .required(i18n.t('registration:form:phone:error'))
            .matches(
              phoneRegExp,
              i18n.t('registration:form:phone:error_valid'),
            ),
          email: yup
            .string()
            .email()
            .required(i18n.t('registration:form:email:error')),
          code: yup.string().required(),
          region: yup
            .string()
            .matches(/^([^0-9]*)$/, i18n.t('registration:form:region:error')),
        })}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(props) => (
          <RegistrationForm
            {...props}
            onChange={handleOnChange}
            isComplete={state.isComplete}
          />
        )}
      </Formik>
      <Backdrop className={classes.backdrop} open={state.isSubmitting}>
        <Loader />
      </Backdrop>
    </Fragment>
  );
};

export default Registration;



// WEBPACK FOOTER //
// ./src/containers/Login/Registration.js